import React from 'react';
import DispatchHeader from './DispatchHeader';
import TrucksTable from './TrucksTable';

const DispatchCard = ({
  dispatch,
  isExpanded,
  currentUser,
  getImportadoraName,
  companies,
  onToggle,
  onDownloadDispatch,
  onDownloadNomina,
  onAssignTruck,
  onEditDispatch,
  onChangeStatus,
  onDeleteDispatch,
  onAddTruckData,
  onModifyTruckData,
  onRemoveTruck,
  onEditTruckAssignment,
  onGenerateLiquidacion,
  onReorderTrucks,
  onUploadPesaje,
  onViewPesaje,
  onDeletePesaje
}) => {
  return (
    <div className="bg-white border border-slate-200 rounded-sm overflow-hidden">
      <DispatchHeader
        dispatch={dispatch}
        isExpanded={isExpanded}
        currentUser={currentUser}
        getImportadoraName={getImportadoraName}
        onToggle={onToggle}
        onDownloadDispatch={onDownloadDispatch}
        onDownloadNomina={onDownloadNomina}
        onAssignTruck={onAssignTruck}
        onEditDispatch={onEditDispatch}
        onChangeStatus={onChangeStatus}
        onDeleteDispatch={onDeleteDispatch}
        onGenerateLiquidacion={onGenerateLiquidacion}
      />
      
      {isExpanded && (
        <div className="bg-slate-50/50">
          <TrucksTable
            dispatch={dispatch}
            companies={companies}
            currentUser={currentUser}
            onAssignTruck={onAssignTruck}
            onAddTruckData={onAddTruckData}
            onModifyTruckData={onModifyTruckData}
            onRemoveTruck={onRemoveTruck}
            onEditTruckAssignment={onEditTruckAssignment}
            onReorderTrucks={onReorderTrucks}
            onUploadPesaje={onUploadPesaje}
            onViewPesaje={onViewPesaje}
            onDeletePesaje={onDeletePesaje}
          />
        </div>
      )}
    </div>
  );
};

export default DispatchCard;
